import { useState ,useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddTermCondition({ userData }) {

    // const [terms, setTerms] = useState("");
    const [terms, setTerms] = useState( "");
      const [loading, setLoading] = useState(false);

  


   const handleSaveTerms = async () => {
    if (!userData?.id) {
      alert("Admin ID is missing!");
      return;
    }

    try {
      setLoading(true);


      const response = await axios.put(
        `https://api.bigfresh.in/add-term-condition/${userData.id}`, 
        {
          bank_name: terms, 
        }
      );

        toast.success("Terms & Conditions saved successfully!", { position: "top-center" });
    } catch (error) {
      console.error("Error saving terms:", error);
       toast.error("Failed to save terms!", { position: "top-center" });
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
   
    fetchTerms();
  }, [userData]);

 const fetchTerms = async () => {
      if (!userData?.id) return;

      try {
        const response = await axios.get(`https://api.bigfresh.in/get-term-condition/${userData.id}`);
        setTerms(response.data.bank_name || "");
      } catch (error) {
        console.error("Failed to fetch terms:", error);
        setTerms(""); 
      }
    };


  return (
 <div className="container my-2">
  <div className="card shadow-sm">
    <div className="card-header bg-success text-white">
      <h5 className="mb-0">Terms & Conditions</h5>
    </div>
    <div className="card-body">
      <div className="mb-3">
        <label htmlFor="termsInput" className="form-label">
          Enter Terms & Conditions
        </label>
        <textarea
          id="termsInput"
          className="form-control"
          rows={5} 
          placeholder="Write your terms & conditions here..."
          value={terms}      
          onChange={(e) => setTerms(e.target.value)}
        ></textarea>
      </div>
       <button
            type="button"
            className="btn btn-success"
            onClick={handleSaveTerms}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
    </div>
  </div>
      <ToastContainer />
</div>
  )
}

export default AddTermCondition